import debounce from 'lodash.debounce';

class GeneralForm {
  constructor({ dom }) {
    this.dom = {
      ...dom
    }

    this.dom.$fileBtn = document.querySelector('[data-sc-field-name="File Upload"]');
    this.dom.$datePicker = document.querySelector('duet-date-picker');

    if (this.dom.$datePicker) {
      this.dom.$datePicker.firstDayOfWeek = 0;
    }


    this.addListeners();
  }

  addListeners() {


    if (this.dom.$fileBtn) {
      // Listen to sitecore form file type click, since label id is dinamically generated
      this.dom.$form._on('click', e => {

        if (e.target.type === 'file') {
          this.handleFile()
        }
      });
      this.dom.$fileBtn._on('change', this.handleFile.bind(this))
      this.dom.$fileBtnRemove._on('click', this.removeFile.bind(this))
    }

    window.addEventListener(
      'resize',
      debounce(this.setMaxHeight.bind(this), 300)
    );

  }

  handleFile() {

    if (this.dom.$fileBtn.files) {

      if (this.dom.$fileBtn.files.length > 1) {
        this.dom.$fileSelected.textContent = `${this.dom.$fileBtn.files.length} files`

      } else {
        this.dom.$fileSelected.textContent = this.dom.$fileBtn.files[0]?.name
      }
    }
    if (this.dom.$fileSelected.textContent !== '') {

      this.dom.$fileContainer.classList.add('show')
    }
  }

  removeFile(e) {
    e.preventDefault();

    if (this.dom.$fileBtn.files.length > 0) {
      this.dom.$fileBtn.value = ''
      this.dom.$fileSelected.textContent = ''
      this.dom.$fileContainer.classList.remove('show')
    }
  }


  setMaxHeight() {
    if (this.isFormWithText && window.matchMedia(`(min-width: ${1024}px)`).matches) {
      this.dom.$parentNode.style.maxHeight = `${this.dom.$form.offsetHeight}px`
      this.dom.$parentNode.style.minHeight = '100%'
    } else {
      this.dom.$parentNode.style.minHeight = `${this.dom.$form.offsetHeight}px`
      this.dom.$parentNode.style.maxHeight = '100%'

    }
  }

}

export default GeneralForm;

